import React from 'react';
import env from 'env';
import QWLogo from '../../icons/qube-wire-logo-new.svg';
import I18n from '../../../config/i18n';

export default class LandingHeader extends React.Component {
  render() {
    return (
      <div className="app__header landing-page-header h6 noselect p2 pb3">
        <div
          className="ui-toolbar"
          style={{ height: '64px', backgroundColor: 'transparent' }}
        >
          <div className="ui-toolbar__group nav-menu mt1">
            <QWLogo className="svg-icon svg-logo-3x" />
          </div>
          <div className="login-buttons">
            <a
              href={`${env.qwPartnersBaseUrl}/v1/web/auth/provider`}
              style={{ color: 'white' }}
            >
              <div className="sm-col login-button">
                {I18n.t('signIn')} | {I18n.t('signUp')}
              </div>
            </a>
          </div>
        </div>
      </div>
    );
  }
}
